import { Injectable } from '@angular/core';
import {
  HttpClient,
  HttpHeaders,
  HttpParams,
  HttpRequest,
  HttpResponse
} from "@angular/common/http";
import { Observable, Subject, BehaviorSubject, of } from "rxjs";
import { fromPromise } from "rxjs/observable/fromPromise";
import { switchMap, tap, filter, first, map, flatMap } from "rxjs/operators";
export interface IRequestOptions {
  headers?: HttpHeaders;
  observe?: "body";
  params?: HttpParams;
  reportProgress?: boolean;
  responseType?: "json";
  withCredentials?: boolean;
  body?: any;
}
export interface IOptionsCache {
  refresh: {
    autoRefresh?: boolean;
    autoTimeRefresh?: boolean;
  }
  maxAge: number;
}
export interface CacheEntry {
  url: string;
  response: HttpResponse<any>;
  entryTime: number;
}
export interface Storage {
  get(key: string): Promise<any>
  set(key: string, data: any): Promise<any>
  remove(key: string)
}
@Injectable()
export class Cache {
  constructor(protected storage: Storage) {
  }
  cacheableTime = new Map<string, number>();
  cacheMap = new Map<string, CacheEntry>();
  get(req: string): Promise<{ data: any; isExpired: boolean }> {
    let entry = this.cacheMap.get(req);
    if (!entry) {
      return this.storage.get(req).then(value => {
        if (value !== null) {
          entry = (value);
          this.cacheMap.set(req, entry);
          let max_time;
          Array.from(this.cacheableTime.keys()).forEach(value => {
            if (entry.url.includes(value)) {
              max_time = this.cacheableTime.get(value);
            }
          });
          const isExpired = Date.now() - entry.entryTime < max_time;
          return Promise.resolve({
            data: entry.response,
            isExpired: isExpired
          });
        } else {
          return Promise.resolve({ data: undefined, isExpired: true });
        }
      });
    } else {
      let max_time;
      Array.from(this.cacheableTime.keys()).forEach(value => {
        if (entry.url.includes(value)) {
          max_time = this.cacheableTime.get(value);
        }
      });
      const isExpired = Date.now() - entry.entryTime < max_time;

      return Promise.resolve({ data: entry.response, isExpired: isExpired });
    }
  }

  put(req: string, res: any): void {
    const entry: CacheEntry = {
      url: req,
      response: res,
      entryTime: Date.now()
    };
    this.cacheMap.set(req, entry);
    this.storage.set(req, JSON.stringify(entry)).then(value => { });
    this.deleteExpiredCache(req);
  }
  protected deleteExpiredCache(url: string) {
    let max_time;
    Array.from(this.cacheableTime.keys()).forEach(value => {
      if (url.includes(value)) {
        max_time = this.cacheableTime.get(value);
      }
    });
    this.cacheMap.forEach(entry => {
      if (Date.now() - entry.entryTime > max_time) {
        this.cacheMap.delete(entry.url);
        this.storage.remove(entry.url);
      }
    });
  }
  public isRequestCachable(req: HttpRequest<any>) {
    const cacheableTime = this.cacheMap.has(req.url) ? req.url : "";
    return req.url.indexOf(cacheableTime) > -1;
  }
}
export function applicationHttpClientCreator(http: HttpClient, cache: Cache) {
  return new CachedHttpService(http, cache);
}
/*
  Generated class for the CacheInterceptService provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable(
  { providedIn: 'root' }

)
export class CachedHttpService {
  private cachedSubjects: Map<string, BehaviorSubject<any>> = new Map();
  cacheableTime = new Map<string, number>();
  constructor(public http: HttpClient, public cache: Cache) { }
  get<T>(
    url: string,
    options?: IRequestOptions,
    optionsCache?: IOptionsCache,

  ): Observable<T> {
    const cacheHandler = new BehaviorSubject<T>(undefined);
    const cacheObResponse$ = cacheHandler
      .asObservable()
      .pipe(filter(a => a !== undefined));
    const cachedResponse = fromPromise(
      this.cache.get(
        this.constructUrl(url, options ? options.params : undefined)
      )
    )
      .pipe(
        flatMap(a => {
          cacheHandler.next(a.data);
          if (a.isExpired === true) {
            return this.http
              .get<T>(url, options)
              .pipe(
                tap(a => {

                  cacheHandler.next(a);
                  this.cache.put(
                    this.constructUrl(url, options ? options.params : undefined),
                    a
                  );
                },
                  map(a => a)),
                first()
              )
          } else {
            return of(a.data);
          }
        }))
      .subscribe();
    this.cachedSubjects.set(
      this.constructUrl(url, options ? options.params : undefined),
      cacheHandler
    );
    return cacheObResponse$;
  }
  private constructUrl(url: string, params?: HttpParams): string {
    return params
      ? url +
      "?" +
      params
        .keys()
        .map(key => key + "=" + params.get(key) + "&")
        .reduce((first, second) => first + second, "")
      : url;
  }
}

